// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-n_fq","advertDetailService__price":"c-n_fr"};